import React, { Component } from 'react';
import Switch from '../../../../Part_Sample/Switch';
import Select from '../../../../Part_Sample/Select';
import { makeTimeString, isEmpty } from '../../../../Common/Common';

export default class Setpoint_Range extends Component {
	constructor(props) {
		super(props);

		let csp_range_lower = 16;
		let hsp_range_lower = 16;
		let csp_range_upper = 32;
		let hsp_range_upper = 32;

		let is_enabled_cool = false;
		let is_enabled_heat = false;

		if (!isEmpty(this.props.point_info)) {
			if (this.props.point_info.csp_limit != null) {
				if (this.props.point_info.csp_limit.length > 0) {
					csp_range_lower = this.props.point_info.csp_limit[0];
					csp_range_upper = this.props.point_info.csp_limit[1]
				}
			}

			if (this.props.point_info.hsp_limit != null) {
				if (this.props.point_info.hsp_limit.length > 0) {
					hsp_range_lower = this.props.point_info.hsp_limit[0];
					hsp_range_upper = this.props.point_info.hsp_limit[1]
				}
			}

			if (this.props.point_info.csp_limit_valid != null) {
				is_enabled_cool = this.props.point_info.csp_limit_valid;
			}

			if (this.props.point_info.hsp_limit_valid != null) {
				is_enabled_heat = this.props.point_info.hsp_limit_valid;
			}
		}

		this.state = {
			is_enabled_cool: is_enabled_cool,
			is_enabled_heat: is_enabled_heat,

			csp_range_lower: csp_range_lower,
			hsp_range_lower: hsp_range_lower,
			csp_range_upper: csp_range_upper,
			hsp_range_upper: hsp_range_upper,
		}
	}

	handleToggleCSPRange = () => {
		let is_enabled_cool = !this.state.is_enabled_cool;

		this.setState({
			is_enabled_cool: is_enabled_cool,
		});


		this.props.handleToggleCSPRange(is_enabled_cool);
	}

	handleToggleHSPRange = () => {
		let is_enabled_heat = !this.state.is_enabled_heat;

		this.setState({
			is_enabled_heat: is_enabled_heat,
		});

		this.props.handleToggleHSPRange(is_enabled_heat);
	}

	handleChangeCSPLower = (value) => {
		this.setState({ csp_range_lower: value });
		let csp_limit = [parseFloat(value), parseFloat(this.state.csp_range_upper)];

		this.props.handleChangeCSPRange(csp_limit);
	}

	handleChangeCSPUpper = (value) => {
		this.setState({ csp_range_upper: value });
		let csp_limit = [parseFloat(this.state.csp_range_lower), parseFloat(value)];

		this.props.handleChangeCSPRange(csp_limit);
	}

	handleChangeHSPLower = (value) => {
		this.setState({ hsp_range_lower: value });
		let hsp_limit = [parseFloat(value), parseFloat(this.state.hsp_range_upper)];

		this.props.handleChangeHSPRange(hsp_limit);
	}

	handleChangeHSPUpper = (value) => {
		this.setState({ hsp_range_upper: value });
		let hsp_limit = [parseFloat(this.state.hsp_range_lower), parseFloat(value)];

		this.props.handleChangeHSPRange(hsp_limit);
	}

	render() {
		const setpointRange = [];

		for (var i = 16; i <= 32; i++) {
			setpointRange.push(<option value={i} key={'sp-' + i}>{i}</option>);
		}

		return (
			<div id='setpoint_range' style={this.props.style}>
				<div style={{ padding: 10, }}>
					<div style={{ marginLeft: 10 }}>
						<span> {this.props.receiver.getString('sp_range')} </span>
					</div>
					<div id='csp_range' style={{ marginTop: 10 }} >
						<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled_cool} handleToggleSwitch={this.handleToggleCSPRange} />
						<div style={{ width: this.props.width - 230, display: 'inline-block', marginLeft: 10, verticalAlign: 'top', paddingTop: 5 }}>
							<span> {this.props.receiver.getString('cool')} </span>
						</div>
						<div style={{ display: 'inline-block', marginLeft: 10, }}>
							<div style={{ display: 'inline-block', marginLeft: 10, width: 60 }}>
								<Select
									options={setpointRange}
									value={this.state.csp_range_lower}
									onSelect={this.handleChangeCSPLower}
								/>
							</div>
							<div style={{ display: 'inline-block', marginLeft: 10, width: 60 }}>
								<Select
									options={setpointRange}
									value={this.state.csp_range_upper}
									onSelect={this.handleChangeCSPUpper}
								/>
							</div>
						</div>
					</div>
					<div id='hsp_range' style={{ marginTop: 10 }}>
						<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled_heat} handleToggleSwitch={this.handleToggleHSPRange} />
						<div style={{ width: this.props.width - 230, display: 'inline-block', marginLeft: 10, verticalAlign: 'top', paddingTop: 5 }}>
							<span> {this.props.receiver.getString('heat')} </span>
						</div>
						<div style={{ display: 'inline-block', marginLeft: 10 }}>
							<div style={{ display: 'inline-block', marginLeft: 10, width: 60 }}>
								<Select
									options={setpointRange}
									value={this.state.hsp_range_lower}
									onSelect={this.handleChangeHSPLower}
								/>
							</div>
							<div style={{ display: 'inline-block', marginLeft: 10, width: 60 }}>
								<Select
									options={setpointRange}
									value={this.state.hsp_range_upper}
									onSelect={this.handleChangeHSPUpper}
								/>
							</div>
						</div>
					</div>
				</div>

			</div>
		)
	}
}